import type { CSSProperties } from 'react';

// Shared styling for the sales comparison report (kept in one place so the table pieces agree).
export const SIGN_COLOR: Record<string, string> = { pos: '#15803d', neg: '#dc2626', neu: '#9ca3af' };

export const SEPARATOR_BORDER: Record<string, string> = {
    's-ct': '2px solid #6c4de6',
    's-nc': '2px dashed #fed7aa',
    's-nt': '2px solid #f97316',
    's-gt': '2px solid #16a34a',
};

export const ROW_BG: Record<string, string | undefined> = {
    current: '#fafafa',
    previous: undefined,
    outcome: '#f0fdf4',
    forecast: '#fff7ed',
    remain: '#fafafa',
};

export const tdBase: CSSProperties = { padding: '5px 8px', borderBottom: '1px solid #e5e7eb', fontSize: 12, whiteSpace: 'nowrap' };
export const thBase: CSSProperties = { ...tdBase, fontWeight: 700, textAlign: 'right' };

export const separatorBorder = (separator?: string): string | undefined => (separator ? SEPARATOR_BORDER[separator] : undefined);
